//首页
export default {
  path: '/',
  name:'index',
  component: resolve => require(['@/components/index'], resolve)
}
